import { ENTITY_UID_REGEX, normalizeOptionalEntityUid } from "le-coffre-resources/dist/Shared/entityUid.js";

/** Same as `ENTITY_UID_REGEX` in le-coffre-resources (login query params). */
export const LOGIN_QUERY_UID_REGEX = ENTITY_UID_REGEX;

export function parseLoginQueryUid(raw: unknown): string | undefined {
	if (typeof raw !== "string") {
		return undefined;
	}
	return normalizeOptionalEntityUid(raw);
}
